import { Switch } from "antd";
import React, { useCallback, useState } from 'react';
import { useDispatch } from "react-redux";
import { TenantService } from "../../../util/services/tenant";
import { ITenant } from "../../../util/varibles/interface";
import { notify, NotifyCode } from "../../../util/varibles/message";
import { userActions } from "../reducer";

interface IProps {
    data: ITenant
}

const WeatherCustomer: React.FC<IProps> = ({ data }) => {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const handleChange = useCallback((weather_license: boolean) => {
        setLoading(true);
        TenantService.editWeatherStatus({ tenant_id: data.tenant_id, weather_license })
            .then(() => {
                notify.success(NotifyCode.S2)(['Weather']);
                dispatch(userActions.updateTenant({ ...data, weather_license }));
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            })
    }, [data, dispatch]);


    return <Switch
        loading={loading}
        checkedChildren="On"
        unCheckedChildren="Off"
        checked={data.weather_license}
        onChange={handleChange}
    />;
};

export default WeatherCustomer;